<template>
    <div>
        <modal :show="show">
            <div class="modal-header">
                <h5 class="modal-title">Forgot Password</h5>
                <a href="javascript:void(0)" v-on:click="close()" class="close">
                    <em class="icon ni ni-cross"></em>
                </a>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-md-12">
                        <div class="form-group">
                            <label class="form-label" for="default-01">Email</label>
                            <div class="form-control-wrap">
                                <input v-model="email" type="text" placeholder="Type your Email" class="form-control" id="default-01">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer bg-light">
                <button v-bind:disabled="$v.$invalid" type="button" class="btn btn-primary btn-round" v-on:click="ForgotPassword()">Submit</button>
                <button type="button" class="btn btn-danger btn-round" v-on:click="close()">Cancel</button>
            </div>
        </modal>
        <loading :name="loading" :active.sync="loading"
                 :can-cancel="false"
                 :is-full-page="true"></loading>
    </div>
</template>
<script>
    import { required ,email} from 'vuelidate/lib/validators';
    import Loading from 'vue-loading-overlay';
    import "vue-loading-overlay/dist/vue-loading.css";

    export default {
        components: {
            Loading
        },
        props: ['path', 'show'],
        data: function () {
            return {
                loading: false,
                email: '',
            }
        },
        methods: {
            close: function () {
                this.$emit('close');
            },

            ForgotPassword : function () {
                var root = this;
                this.loading = true;
                
                root.$https.get('/account/ForgotPassword?email='+ this.email)
                    .then(function (response) {
                        console.log(response.data)
                        if (response.data.isSuccess) {
                            root.loading = false;
                            root.$swal({
                                title: 'Sent!',
                                text: response.data.isAddUpdate,
                                type: 'success',
                                icon: 'success',
                                confirmButtonClass: "btn btn-success",
                                buttonsStyling: false
                            }).then(function (result) {
                                if (result) {
                                    root.close();
                                }
                            });
                        }
                        else {
                            root.$swal({
                                title: 'Error!',
                                text: response.data.isAddUpdate,
                                type: 'error',
                                icon: 'error',
                                confirmButtonClass: "btn btn-info",
                                buttonsStyling: false
                            });
                            root.loading = false;
                        }
                    }).catch(error => {
                        console.log(error)
                        root.$swal.fire(
                            {
                                icon: 'error',
                                type: 'error',
                                title: 'Error',
                                text: "Something Went Wrong",
                                showConfirmButton: false,
                                timer: 5000,
                                timerProgressBar: true,
                            });

                        root.loading = false;
                    })
                    .finally(() => root.loading = false);
            },

        },
        validations: {
            email:
            {
                required,
                email
            },
        },
        mounted: function () {

        },

    }
</script>